import { api } from '../../utils/data-utils';
import type {
  RpaLoginActionCommand,
  RpaLoginActionId,
  RpaLoginActionResponse,
  RpaLoginActionStatusResponse,
} from './rpaLoginConfig';

export const fetchRpaLoginStatuses = async (
  token: string,
): Promise<RpaLoginActionStatusResponse> => {
  const response = await api(token, '/rpalogin/action', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  return (await response.json()) as RpaLoginActionStatusResponse;
};

export const runRpaLoginAction = async (
  token: string,
  action: RpaLoginActionId,
  command: RpaLoginActionCommand,
): Promise<RpaLoginActionResponse> => {
  const response = await api(token, '/rpalogin/action', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action, command }),
  });

  return (await response.json()) as RpaLoginActionResponse;
};
